import { ReactElement, useCallback, useState } from 'react';
import { Icon, ICON_NAME } from 'b2b-components/theme/components/Icon';
import { IconUSBChargerSpecs } from 'b2b-components/theme/components/Icon/Icons';
import { Modal } from 'b2b-components/theme/components/Modal';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import { Props } from './USBCharger.types';
import { USBChargerPDDescription } from './USBChargerPDDescription';
import './USBCharger.scss';

export const USBCharger = ({
  usbChargerIncluded,
  usbPowerDeliverySupported,
  requiredChargingPowerMin,
  requiredChargingPowerMax,
}: Props): ReactElement => {
  const t = useTranslate();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const onClick = useCallback(() => {
    setIsModalOpened(true);
  }, [setIsModalOpened]);

  const usbChargerIcon = (
    <Icon name={usbChargerIncluded ? ICON_NAME.usbChargerIncluded : ICON_NAME.usbChargerNotIncluded} />
  );

  const usbChargerSpecsIcon = (
    <IconUSBChargerSpecs
      className='cds-Icon'
      hasUsbPd={usbPowerDeliverySupported}
      minPower={requiredChargingPowerMin}
      maxPower={requiredChargingPowerMax} />
  );

  return (
    <div className='ProductData-USBCharger'>
      <button className='ProductData-USBCharger-IconButton' onClick={onClick}>{usbChargerIcon}</button>
      <button className='ProductData-USBCharger-IconButton' onClick={onClick}>{usbChargerSpecsIcon}</button>
      <div className='ProductData-USBCharger-Description'>
        <span>
          {usbChargerIncluded ? t('Charger included') : t('Charger not included')}
        </span>
        <span>
          <USBChargerPDDescription
            usbPowerDeliverySupported={usbPowerDeliverySupported}
            requiredChargingPowerMin={requiredChargingPowerMin}
            requiredChargingPowerMax={requiredChargingPowerMax}
          />
        </span>
      </div>

      <Modal
        isOpen={isModalOpened}
        onCloseModal={() => setIsModalOpened(false)}
        title={t('Matching Charger')}
        content={() => <div className='ProductData-USBCharger-Modal'>
          <div className='ProductData-USBCharger-Modal-Icons'>
            {usbChargerIcon}
            {usbChargerSpecsIcon}
          </div>

          <span>
            {usbChargerIncluded
              ? t('Charger included')
              : t('For environmental reasons this package does not include a charger. You can purchase a compatible charging adapter separately.')}
          </span>

          <span className='ProductData-USBCharger-Modal-DescriptionStats'>
            {t('This device can be powered with most USB power adapters and a cable with USB Type-C plug.')}
            <ul>
              {requiredChargingPowerMin && <li>{t('Minimum power (watts) required to charge the product:')} <b>{requiredChargingPowerMin} W</b></li>}
              {requiredChargingPowerMax && <li>{t('Power (watts) required to achieve the fastest possible charging speed:')} <b>{requiredChargingPowerMax} W</b></li>}
              {usbPowerDeliverySupported && <li>
                {t('The abbreviation \'USB PD\' stands for USB Power Delivery. It indicates that the fast charging function is supported.')}
              </li>}
            </ul>
          </span>
        </div>} />
    </div>
  );
};
